
import { Vue, prop, Options } from "vue-class-component";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { AccountController } from "@/app/ui/controllers/AccountController";
import formatPriceRP from "@/app/infrastructures/misc/common-library/v2/FormatPriceRP";
import { getCurrencyByCountryCode } from "@/app/infrastructures/misc/common-library/modules/v2/Price";
import mapProductTypeName from "@/app/infrastructures/misc/common-library/ProductTypeNameMapper";

class Props {
  detailData = prop<any>({
    default: {},
    type: Object
  });
  formAccountCurrencyPrefix = prop<string>({
    default: "Rp",
    type: String
  });
}
export default class DetailItemSection extends Vue.with(Props) {
  formatByCountry = formatByCountry;
  get isEnableCodBooking() {
    return FlagsMedusa.config_new_cod_booking_enable.isEnabled();
  }

  get sttBookedByCountry(): string {
    return this.detailData?.sttBookedByCountry ?? "ID";
  }

  get getDimension() {
    const dimensions = [];
    for (const item of this.detailData.SttPieces) {
      const dimension = `${item.dimension.length} x ${item.dimension.width} x ${item.dimension.height}`;
      dimensions.push(dimension);
    }

    return dimensions.join(" <br>");
  }

  get typeCod() {
    if (this.detailData.sttCod.toLowerCase() === "yes") {
      return this.detailData.sttIsDfod ? "DFOD" : "COD";
    }
    return "-";
  }

  get productTypeName() {
    return mapProductTypeName(this.detailData.sttProductTypeName);
  }

  get sttCurrency(): "IDR" | "MYR" {
    return getCurrencyByCountryCode(
      this.detailData?.sttBookedByCountry ?? "ID"
    ) as "IDR" | "MYR";
  }

  formatPrice(value: any, _prefix = "", currency?: "IDR" | "MYR") {
    if (this.detailData.sttDestinationCountryCode && this.detailData.sttCod.toLowerCase() === "yes") {
      const hasFraction = (num: number) => {
        return typeof num === 'number' && !Number.isInteger(num);
      }
      return `${this.formAccountCurrencyPrefix}${formatByCountry(value, {
        type: "money",
        country: this.detailData.sttDestinationCountryCode,
        fractionDigits: hasFraction(value) ? 2 : 0,
        minFractionDigits: hasFraction(value) ? 2 : 0
      })}`
    }

    const curr = currency ?? this.sttCurrency;
    const num = Number(value);
    return formatPriceRP(num, curr);
  }

  photoPreview = false;
  photo = "";
  onPreview(photo: string) {
    this.photo = photo;
    this.photoPreview = true;
  }

  get photoPreviews() {
    return this.detailData.sttWeightAttachFiles.map((item: any) => {
      return {
        image: item,
        url: item
      };
    });
  }
}
